import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles";

const useStyles = makeStyles((theme: Theme) => ({
    container: {
        display: "flex",
        justifyContent: "flex-start",
        alignItems: "center",
    },
    bold_title: {
        color: "#000000",
        fontSize: "35px",
        letterSpacing: 0,
    },

    right_title: {
        fontSize: "20px",
        letterSpacing: 0,
        color: "#000000",
        marginTop: "10px",
    },
    mobile_title: {
        color: "#000000",
        fontSize: "26px",
        letterSpacing: 0,
    },
}));

export default useStyles;
